import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-salesforce-crm-dev',
  templateUrl: './salesforce-crm-dev.component.html',
  styleUrls: ['./salesforce-crm-dev.component.css']
})
export class SalesforceCrmDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/salesforce-crm-dev/salesforce-crm-dev.component.ts